import script from "./OIDCCallback.vue?vue&type=script&setup=true&lang=js"
export * from "./OIDCCallback.vue?vue&type=script&setup=true&lang=js"

import "./OIDCCallback.vue?vue&type=style&index=0&id=d4698e5e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d4698e5e"]])

export default __exports__